export enum ResponseType {
    SUCCESS = 'success',
    FAIL = 'fail',
    Declined = 'declined'
}
